import {
	MultiAPIInputType,
	GraphQLErrorResponseType,
	GraphQLOperaionInputType,
	DeleteRecordInputType,
	GetRecordInputType,
} from '../type/GraphQLOperationType';
import { GraphQLError } from 'graphql';

/**
 * GraphQLのInputの型がMultiAPIInputTypeであるかを判定する
 */
export const isMultiInput = (input: GraphQLOperaionInputType): input is MultiAPIInputType => {
	return 'offsegInput' in input && 'g500LiteInput' in input;
};

/**
 * GraphQLのInputの型がDeleteRecordInputTypeであるかを判定する
 */
export const isDeleteRecordInput = (input: GraphQLOperaionInputType): input is DeleteRecordInputType => {
	return 'input' in input && 'id' in input.input;
};

/**
 * GraphQLのInputの型がGetRecordInputTypeであるかを判定する
 */
export const isGetRecordInput = (input: GraphQLOperaionInputType): input is GetRecordInputType => {
	return 'id' in input;
};

/**
 * エラーの型がGraphQLErrorResponseTypeであるかを判定する
 */
export const isGraphQLErrorResponse = (err: unknown): err is GraphQLErrorResponseType => {
	return (
		err !== null &&
		typeof err === 'object' &&
		Array.isArray((err as GraphQLErrorResponseType).errors) &&
		(err as GraphQLErrorResponseType).errors[0] instanceof GraphQLError
	);
};
